module.exports = angular;


/*****************
 ** WEBPACK FOOTER
 ** external "angular"
 ** module id = 27
 ** module chunks = 0
 **/